import {
  AuthAccountContactTypeChoices,
  ContactType,
  GetOrganizationInformationAndCredentialsQuery,
} from "@graphql/generated";
import { useEffect } from "react";
import { UseFormReset } from "react-hook-form";
import { ICompanyInformationFormData } from "../formConfig";

export type OrganizationInformationAndCredentials = NonNullable<
  NonNullable<NonNullable<GetOrganizationInformationAndCredentialsQuery["admin"]>["organizations"]>["edges"][0]
>["node"];

export const getContactByType = (
  contacts: (ContactType | null)[] | null | undefined,
  type: AuthAccountContactTypeChoices,
) => contacts?.find((item) => item?.type === type)?.value;

export const useOrganizationInformationFormData = ({
  reset,
  organization,
}: {
  reset: UseFormReset<ICompanyInformationFormData>;
  organization?: OrganizationInformationAndCredentials;
}) => {
  useEffect(() => {
    if (organization) {
      reset({
        name: organization.name,
        shortName: organization.shortName ?? undefined,
        industry: organization.industry?.id,
        businessType: organization.businessType ?? undefined,
        about: organization.about ?? undefined,
        size: organization.size ?? undefined,
        establishedAt: organization.establishedAt,
        nationalNumber: organization.nationalNumber ?? undefined,
        type: organization.type ?? undefined,
        email: organization.email ?? undefined,
        website: getContactByType(organization.contacts, AuthAccountContactTypeChoices.WEBSITE) ?? undefined,
        address: getContactByType(organization.contacts, AuthAccountContactTypeChoices.ADDRESS) ?? undefined,
        contactNumber: getContactByType(organization.contacts, AuthAccountContactTypeChoices.PHONE) ?? undefined,
        city: organization.city?.id ?? undefined,
      });
    }
  }, [organization, reset]);

  return { getContactByType };
};
